import {
  GET_DOCUMENT_TYPE_TURN_DOWNLOAD_FAILURE,
  GET_DOCUMENT_TYPE_TURN_DOWNLOAD_REQUEST,
  GET_DOCUMENT_TYPE_TURN_DOWNLOAD_SUCCESS,
  GET_DOCUMENT_TYPE_TURN_FAILURE,
  GET_DOCUMENT_TYPE_TURN_REQUEST,
  GET_DOCUMENT_TYPE_TURN_SUCCESS,
} from "./document-typeTurnTypes";
import axios from "axios";
import Config from "../../../config/index";

let baseUrl = Config.baseUrl;
let baseUrlReport = Config.baseUrlReport;

const getDocumentTypeTurnAroundTimeRequest = () => {
  return {
    type: GET_DOCUMENT_TYPE_TURN_REQUEST,
  };
};

const getDocumentTypeTurnAroundTimeSuccess = (payload) => {
  return {
    type: GET_DOCUMENT_TYPE_TURN_SUCCESS,
    payload: payload,
  };
};

const getDocumentTypeTurnAroundTimeFailure = (error) => {
  return {
    type: GET_DOCUMENT_TYPE_TURN_FAILURE,
    payload: error,
  };
};

const getDocumentTypeTurnAroundTime = (
  pageNo,
  rowsPerPage,
  search,
  documentId,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getDocumentTypeTurnAroundTimeRequest());
    // let url = `${baseUrlReport}/reports/doc_type_turn_around_time?documentId=${documentId}`;

    let url = `${baseUrlReport}/doc_type_turn_around_time?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&documentId=${documentId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDocumentTypeTurnAroundTimeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDocumentTypeTurnAroundTimeFailure(err.message));
      });
  };
};
const getDocumentTypeTurnAroundTimeDownloadRequest = () => {
  return {
    type: GET_DOCUMENT_TYPE_TURN_DOWNLOAD_REQUEST,
  };
};

const getDocumentTypeTurnAroundTimeDownloadSuccess = (payload) => {
  return {
    type: GET_DOCUMENT_TYPE_TURN_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const getDocumentTypeTurnAroundTimeDownloadFailure = (error) => {
  return {
    type: GET_DOCUMENT_TYPE_TURN_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const getDocumentTypeTurnAroundTimeDownload = (
  pageNo,
  rowsPerPage,
  search,
  documentId,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getDocumentTypeTurnAroundTimeDownloadRequest());
    // let url = `${baseUrl}/reports/doc_type_turn_around_time?documentId=${documentId}`;
    let url = `${baseUrlReport}/doc_type_turn_around_time?download=1&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&documentId=${documentId}`;
  
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDocumentTypeTurnAroundTimeDownloadSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getDocumentTypeTurnAroundTimeDownloadFailure(err.message));
      });
  };
};

export { getDocumentTypeTurnAroundTime ,getDocumentTypeTurnAroundTimeDownload};
